export function getTextFilterType(prevVal, nextVal) {
  if (prevVal === nextVal) {
    return null;
  }

  const hadValue = prevVal && prevVal.length > 0;
  const hasValue = nextVal && nextVal.length > 0;

  return hadValue && hasValue ? 'throttled' : 'immediate';
}

function getArrayFilterSignature(value) {
  if (!value) {
    return null;
  }

  return value.join('');
}

export function getFilterChangeTypes(prevFilters, nextFilters, {
  textFilterKeys = [],
  immediateFilterKeys = [],
  arrayFilterKeys = [],
  throttledArrayFilterKeys = [],
} = {}) {
  let throttledFiltersChanged = false;
  let filtersChanged = false;

  textFilterKeys.forEach((key) => {
    const mode = getTextFilterType(prevFilters[key], nextFilters[key]);
    if (mode === 'throttled') {
      throttledFiltersChanged = true;
    }
    if (mode === 'immediate') {
      filtersChanged = true;
    }
  });

  immediateFilterKeys.forEach((key) => {
    if (prevFilters[key] !== nextFilters[key]) {
      filtersChanged = true;
    }
  });

  arrayFilterKeys.forEach((key) => {
    if (getArrayFilterSignature(prevFilters[key]) !== getArrayFilterSignature(nextFilters[key])) {
      filtersChanged = true;
    }
  });

  throttledArrayFilterKeys.forEach((key) => {
    if (getArrayFilterSignature(prevFilters[key]) !== getArrayFilterSignature(nextFilters[key])) {
      throttledFiltersChanged = true;
    }
  });

  return { throttledFiltersChanged, filtersChanged };
}



// WEBPACK FOOTER //
// ./src/utils/filterChangeTypes.js